'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1408 1024' }, props, {
        style: { width: '1.38em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M768 705.306v-13.256c92.524-35.408 160-145.59 160-276.050 0-159.058-100.29-288-224-288-123.712 0-224 128.942-224 288 0 130.46 67.476 240.642 160 276.050v13.256c-217.102 8.874-384 62.21-384 126.694v128h896v-128c0-64.484-166.898-117.82-384-126.694z' }),
        React.createElement('path', { d: 'M1152 448.592v-5.078c73.032-20.754 128-111.146 128-219.514 0-123.712-71.634-224-160-224s-160 100.288-160 224c0 108.37 54.968 198.76 128 219.514v5.078c-31.81 1.172-62.054 4.074-89.878 8.412-6.28 68.208-28.092 131.24-61.738 182.996h471.616v-96c0-49.414-112.006-90.1-256-95.408z' }),
        React.createElement('path', { d: 'M409.878 457.004c-27.824-4.338-58.070-7.24-89.878-8.412v-5.078c73.032-20.754 128-111.146 128-219.514 0-123.712-71.634-224-160-224s-160 100.288-160 224c0 108.37 54.968 198.76 128 219.514v5.078c-143.994 5.308-256 45.994-256 95.408v96h471.618c-33.646-51.756-55.458-114.788-61.74-182.996z' })
    ));
};